import axios from 'axios';
import { SearchSupportDto } from '../types/support/SearchSupportDto';
import {PotalCommDto} from '../types/PotalCommDto';
import config from '../config';

interface ApiListResponse {
  status: string;
  data?: any[];
  meta?: PotalCommDto
  error?: {
    code: string;
    message: string;
  };
}

interface ApiResponse {
  status: string;
  data?: any;
  meta?: PotalCommDto
  error?: {
    code: string;
    message: string;
  };
}

interface SuccessResponse<T> {
  status: 'success';
  data: T;
}

interface ErrorResponse {
  status: 'error';
  error: {
    code: string;
    message: string;
  };
}


export async function getComboList(searchCommonDto: any): Promise<any | null> {
  try {
    const response = await axios.get<Promise<ApiListResponse> | null>(
      `${config.portalApiUrl}/comm/combo`,
      {
        headers: {
          'x-ncp-apigw-api-key': config.portalApiKey,
        },
        params: searchCommonDto,
      }
    );

    return response.data;
  } catch (error) {
    console.error('Failed to create user:', error);
    return {
      status: 'error',
      error: {
        code: 'INTERNAL_SERVER_ERROR',
        message: 'Failed to create user',
      },
    };
  }
};

export async function getFileDownLoad(fileName:string, fileType : string , groupId : number , fileId : number): Promise<void | null> {

  try {
    const response = await fetch(
      `${config.portalApiUrl}/common/fileDownload?fileType=${fileType}&groupId=${groupId}&fileId=${fileId}`,
      {
        method: "GET",
        headers: {
          'x-ncp-apigw-api-key': config.portalApiKey,
        }
      }
    );

    if (!response.ok) {
      const error = await response.text();
      console.error("다운로드 실패:", error);
      alert("파일 다운로드 실패: " + response.status);
      return;
    }

    const blob = await response.blob();

    // 파일 이름 가져오기
    
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

  } catch (err) {
    console.error("다운로드 중 에러:", err);
    alert("파일 다운로드 중 오류 발생");
  }
}

export async function deleteFile(searchCommonDto: any): Promise<any | null> {
  try {
    const access_token  = localStorage.getItem('access_token');
    const response = await axios.delete<Promise<ApiResponse> | null>(
      `${config.portalApiUrl}/common/deleteFile`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'x-ncp-apigw-api-key': config.portalApiKey,
        },
        params : searchCommonDto 
      }
      
    );

    // console.log('삭제 결과 api:', JSON.stringify(response.data, null, 2));

   //  const response = await axios.post(`${config.portalApiUrl}/notices`, formData);
    return response.data;
  } catch (error) {
    // console.log('저장 결과 error api:', JSON.stringify(error, null, 2));
    return {
      status: 'error',
      error: {
        code: 'INTERNAL_SERVER_ERROR',
        message: 'Failed to delete file',
      },
    };
  }
};


